var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarCurrentColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 12.828l-2.73 1.51c-.483.266-1.092.091-1.359-.392-.108-.197-.148-.424-.112-.645l.534-3.274-2.307-2.365c-.386-.396-.378-1.029.017-1.414.15-.146.341-.242.547-.273l.61-.093 2.534-.387 1.36-2.9c.235-.5.83-.715 1.33-.48.212.1.382.269.481.48l1.361 2.9 3.144.48c.545.083.92.594.837 1.14-.032.206-.127.397-.273.547l-2.307 2.365.534 3.274c.089.545-.281 1.059-.826 1.148-.222.036-.449-.003-.645-.112L8 12.828z",
    transform: "translate(-217 -289) translate(163 289) translate(54)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCurrentColor);
export default __webpack_public_path__ + "static/media/star-current-color.f8893d4e.svg";
export { ForwardRef as ReactComponent };